import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

// styles
import { HeroSizer, HeroImageStyled } from "./styles";

const HeroImage = () => {
    const { state } = useContext(AssetDownloadContext);
    const { asset } = state;
    const { title, assets, ratio } = asset;

    return (
        <HeroImageStyled data-testid="photo-hero-image-body" ratio={ratio}>
            <HeroSizer>
                <img src={assets.thumbnailLarge} alt={title} title={title} />
            </HeroSizer>
        </HeroImageStyled>
    );
};

export default HeroImage;
